module.exports = "/packs/media/images/MedicalExpense-b5b8feff24edc75aa17db8ba556c0256.png";